import { Stakeholder } from '@/models/StakeholderModels';

export type State = {
  stakeholder: Array<Stakeholder>;
};

export const state: State = {
  stakeholder: sessionStorage.getItem('stakeholder') != null ? JSON.parse(sessionStorage.stakeholder) : new Array<Stakeholder>(),
};
